<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { slide } from 'svelte/transition';
  import { cn } from "$lib/components/shadcn/utils.js";
  import { ChevronDown, ChevronUp } from 'lucide-svelte';

  export let open = true;
  export let title = "";
  export let headerClass = "";
  export let contentClass = "";
  export let icon = true;
  export let iconPosition = "right";

  const dispatch = createEventDispatcher<{ toggle: boolean }>();

  function toggle() {
    open = !open;
    dispatch('toggle', open);
  }
</script>

<div class={cn("border rounded-lg overflow-hidden", $$props.class)}>
  <button
    type="button"
    on:click={toggle}
    class={cn(
      "w-full flex items-center justify-between p-2 text-left bg-card hover:bg-accent/50 transition-colors",
      headerClass
    )}
  >
    <div class="flex items-center gap-2">
      {#if icon && iconPosition === "left"}
        {#if open}
          <ChevronUp size={18} />
        {:else}
          <ChevronDown size={18} />
        {/if}
      {/if}
      
      <slot name="header">
        {#if title}
          <h3 class="font-medium">{title}</h3>
        {/if}
      </slot>
    </div>
    
    {#if icon && iconPosition === "right"}
      {#if open}
        <ChevronUp size={18} />
      {:else}
        <ChevronDown size={18} />
      {/if}
    {/if}
  </button>
  
  {#if open}
    <div 
      transition:slide={{ duration: 300 }}
      class={cn(contentClass)}
    >
      <slot />
    </div>
  {/if}
</div> 